<template>
  <v-layout row wrap class="pending-cards-container">
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card total mb-2"
        flat
        color="grey lighten-3"
        height="90"
      >
        <v-card-title class="pb-0 custom-title">TOTAL</v-card-title>
        <v-card-text class="pt-0">
          <strong class="amount">{{ folders.length }}</strong>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card reviews mb-2"
        flat
        height="90"
      >
        <v-card-title class="pb-0 custom-title">REVISÕES</v-card-title>
        <v-card-text class="pt-0">
          <strong class="amount">{{ reviews.length }}</strong>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="pa-2">
      <v-card
        class="custom-card signatures mb-2"
        flat
        height="90"
      >
        <v-card-title class="pb-0 custom-title">ASSINATURAS</v-card-title>
        <v-card-text class="pt-0">
          <strong class="amount">{{ signatures.length }}</strong>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'pending-cards',
  props: ['folders'],
  computed: {
    reviews() {
      const reviews = this.folders.filter(item => item.pending_type === 'review');
      return reviews;
    },
    signatures() {
      const signatures = this.folders.filter(item => item.pending_type === 'signature');
      return signatures;
    },
    // TODO: Ask for API developers to return the done folders in this section
    done() {
      const done = this.folders.filter(item => item.received_status === 'done');
      return done;
    },
  },
};
</script>

<style scoped lang="scss">
.pending-cards-container {
  margin: 16px 0;
}

.custom-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }

  .custom-title {
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #616161;
  }

  .amount {
    font-size: 1.75rem;
    font-weight: 700;
    display: block;
    margin-top: 4px;
  }

  &.total {
    background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important;
    .amount { color: #424242; }
  }

  &.reviews {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%) !important;
    .amount { color: #ef6c00; }
  }

  &.signatures {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
    .amount { color: #1565c0; }
  }

  &.done {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;
    .amount { color: #2e7d32; }
  }
}

@media (max-width: 600px) {
  .custom-card {
    .custom-title {
      font-size: 0.75rem;
    }
    .amount {
      font-size: 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/pending/PendingCards.vue